export default __webpack_public_path__ + "static/media/human_rights_due_diligence.f946f079.svg";